export default (function (siteVars) {
  return {
    selectableFocusHoverBackgroundColor: siteVars.colors.grey[500],
    selectedBackgroundColor: siteVars.colors.grey[500]
  };
});